exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @prettier\n */\n@media screen and (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\ninput.hiddenInput___2Gzph {\n  display: none;\n}\ninput[type=\"file\"].hiddenInput___2Gzph {\n  display: none;\n}\n.crop___dJGsF {\n  margin: auto 20px;\n}\n.crop___dJGsF img {\n  height: 100%;\n  max-height: 100%;\n  max-width: 450px;\n  width: 100%;\n}\n.dropzoneText___2WJvN {\n  color: #505050;\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 20px;\n  margin-top: 12px;\n}\n.dropzoneBox___1zSVt {\n  align-items: center;\n  background-color: #f5f9fc;\n  border: dashed 2px #c9d6ec;\n  flex: 1 1 100%;\n  flex-direction: column;\n  margin: 20px 0;\n  padding: 32px;\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"hiddenInput": "hiddenInput___2Gzph",
	"crop": "crop___dJGsF",
	"dropzoneText": "dropzoneText___2WJvN",
	"dropzoneBox": "dropzoneBox___1zSVt"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/SingleSample/PhotoUpload/styles.module.less
// module id = 1741
// module chunks = 70